import React from 'react';
import PropTypes from 'prop-types';
import CalendarIcon from "../../../Icons/CalendarIcon";
import {DatePicker, DropInput, DropInputContent} from '../../../index';
import {t} from 'ttag';

const DatePickerInput = ({open, label, placeholder, date, onFocus, onBlur, onChange, DropInputProps, DatePickerProps, containerRef, clearHandler, disabled, error}) => {

    return (
        <DropInput
            label={label}
            value={date ? date.format('DD MMMM') : ''}
            placeholder={placeholder}
            fullWidth
            readOnly
            containerRef={containerRef}
            clearHandler={clearHandler}
            adornmentIcon={<CalendarIcon/>}
            disabled={disabled}
            onFocus={onFocus}
            onBlur={onBlur}
            open={open}
            error={error}
            {...DropInputProps}
        >
            <DropInputContent className={'azo-date-picker-input'} p={1}>
                <DatePicker
                    start={date}
                    end={date}
                    selectedDateHandler={onChange}
                    abstractToDecades={false}
                    disabled={disabled}
                    pastDisabled
                    // monthOverflowDaysVisible={false}
                    // acceptKeyboardControls
                    t={s => {
                        const monthNames = {
                            January: t`January`,
                            February: t`February`,
                            March: t`March`,
                            April: t`April`,
                            May: t`May`,
                            June: t`June`,
                            July: t`July`,
                            August: t`August`,
                            September: t`September`,
                            October: t`October`,
                            November: t`November`,
                            December: t`December`,
                        };
                        return monthNames.hasOwnProperty(s) ? monthNames[s] : s;
                    }}
                    {...DatePickerProps}
                />
            </DropInputContent>
        </DropInput>
    );
};

DatePickerInput.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    date: PropTypes.shape({
        format: PropTypes.func,
    }),
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    DropInputProps: PropTypes.object,
    DatePickerProps: PropTypes.object,
    containerRef: PropTypes.any,
    clearHandler: PropTypes.func,
    disabled: PropTypes.bool,
    open: PropTypes.bool,
    error: PropTypes.bool,
};

DatePickerInput.defaultProps = {
    label: 'Date input',
    placeholder: 'Date',
    date: null,
    onChange: date => null,
    onFocus: e => null,
    onBlur: e => null,
    DropInputProps: {},
    DatePickerProps: {},
    clearHandler: null,
    disabled: false,
    open: false,
    error: false,
};

export default DatePickerInput;